<template>
  <div id="app">
    <Header routeValue="4-1"></Header>
    <content class="help-list">
      <div :class="scroll>53?'banner_scroll':'banner_box'">
        <div class="search_section" :style="{marginTop:scroll>53?'72px':'100px'}">
           <span>
            <a-input
              placeholder="Search for answers"
              @pressEnter="onSearch"
              allow-clear>
              <a-icon slot="prefix" type="search"/>
            </a-input>
          </span>
        </div>
      </div>
      <div class="container_des">
        <div class="nav_bar">
          <img src="@/assets/icon/arrow2.png" style="margin-right: 10px">
          {{ selectedObj ? selectedObj.name : '' }}
        </div>
        <div class="content_box">
          <div style="width: 344px;margin-right: 20px">
            <div :class="scroll>53?'item_scroll':'item_view'">
              <div class="item_l" v-for="item in dataList">
                <a :href="item.prefix + item.link" @click="handleToPage($event,item)">
                  <div class="divider" :style="{background:item.isSelected?'#2D3E50':''}"></div>
                  <div class="title" :style="{fontWeight:item.isSelected?'bold':''}">
                    {{ item.name }}
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="item_view" :style="{marginTop:scroll>53?'240px':'' }">
            <div class="select_box" v-if="selectedObj">
              <div class="name">{{ selectedObj.name }}</div>
              <div class="des">{{ selectedObj.remark }}</div>
              <div class="divider"></div>
            </div>
            <div class="item_r" v-for="help in selectedObj.helpDetailVOS">
              <a :href="help.prefix + help.link">
                <div class="title">
                  {{ help.name }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import {get} from '@/api'
import {getSeoLinkName} from '@/utils/utils'

export default {
  name: 'HelpList',
  components: {
    Header,
    Footer,
  },
  data () {
    return {
      link: '',
      scroll: 0,
      dataList: [],
      selectedObj: {}
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.$router.beforeEach((to, from, next) => {
      this.link = to.params.link
      this.dataList.forEach((item => {
        item['isSelected'] = this.link === item.link
      }))
      this.updateSelectedObj()
      next()
    })
  },
  created () {
    this.link = this.$route.params.link
    this.listHelpIndex()
  },
  methods: {
    handleScroll () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
    },
    listHelpIndex () {
      get('/merchant/message/help/index')
        .then(response => {
          this.dataList = response.data
          this.dataList.forEach(item => {
            item.link = getSeoLinkName(item.name)
            item.prefix = '/help/list/'
            item['isSelected'] = this.link === item.link
          })
          this.updateSelectedObj()
        }).catch(error => {
        console.error(error)
      })
    },
    updateSelectedObj () {
      this.selectedObj = this.dataList.find(obj => obj.link === this.link)
      if (this.selectedObj) {
        this.selectedObj.helpDetailVOS.forEach(item => {
          item.prefix = '/help/details/'
        })
      }
    },
    onSearch (row) {
      window.location.href = `/help/search-results?term=${row.target.value}`
    },
    handleToPage (event, item) {
      event.preventDefault()
      if (this.$route.fullPath !== item.prefix + item.link) {
        this.$router.push({path: item.prefix + item.link})
      }
    },
  },
}
</script>
<style scoped lang="less">
.help-list {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  min-height: 855px;
  font-family: HarmonyOS Sans SC;

  .banner_scroll {
    width: 100%;
    height: 140px;
    background-image: url(../../assets/icon/banner_bg2.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: fixed;
    top: 20px;
    z-index: 100;
  }

  .banner_box {
    height: 190px;
    background-image: url(../../assets/icon/banner_bg1.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    //margin-top: 72px;
  }

  .search_section {
    width: 1052px;
    display: flex;
    flex-direction: column;
    margin-left: 425px;
    margin-top: 100px;

    /deep/ .ant-input {
      height: 50px;
      border-radius: 4px;
      font-size: 15px;
      font-weight: 400;
      background: #FFFFFF;
    }
  }

  .container_des {
    position: relative;
    width: 100%;
    max-width: 1052px;
    margin-left: 425px;
    float: none !important;
    display: flex;
    flex-wrap: wrap;

    .nav_bar {
      font-weight: 400;
      font-size: 13px;
      margin-top: 17px;
      color: #33475B;
    }

    .content_box {
      width: 100%;
      margin-top: 52px;
      display: flex;
      margin-bottom: 52px;

      .item_scroll {
        position: fixed;
        top: 170px;
      }

      .item_view {
        display: flex;
        flex-direction: column;
      }

      .item_l {
        width: 344px;
        margin-right: 20px;

        a:hover {
          .divider {
            width: 3px;
            height: 25px;
            background: #2D3E50;
          }
        }

        a {
          width: 240px;
          height: 40px;
          display: flex;
          align-items: center;
          cursor: pointer;

          .divider {
            width: 3px;
            height: 25px;
            background: transparent;
          }

          .title {
            font-weight: 400;
            font-size: 14px;
            color: #33475B;
            margin-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .select_box {
        width: 688px;

        .name {
          font-weight: 500;
          font-size: 32px;
          color: #33475B;
          line-height: 40px;
        }

        .des {
          font-weight: 400;
          font-size: 14px;
          color: #33475B;
          margin-top: 10px;
        }

        .divider {
          height: 1px;
          background: #DFE3EB;
          margin: 22px 0 22px 0;
        }
      }

      .item_r {
        width: 688px;

        a:hover {
          text-decoration: underline;
        }

        a {
          width: auto;

          .title {
            font-weight: 400;
            font-size: 14px;
            color: #33475B;
            line-height: 36px;
          }
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help/HelpList.vue